import React from 'react';

export type SvgOrGroupProps = {
  groupIdPrefix?: string;
  wantsCurrentColor?: boolean;
  wantsColor?: string;
};

export type SvgProps = SvgOrGroupProps & {
  svg?: React.SVGProps<SVGSVGElement>;
  group?: React.SVGProps<SVGGElement>;
  size?: number;
};

export type SvgCenterProps = {
  center?: boolean;
};

export const toSvgColor = (defaultColor: string, props: SvgOrGroupProps) => {
  if (props.wantsCurrentColor) {
    return 'currentColor';
  }
  if (props.wantsColor) {
    return props.wantsColor;
  }
  return defaultColor;
};
